'use strict';

const ritualsStyles = require('../../rituals-styles');
const scrollHelper = require('../../modules/helpers/scroll');
const giftsetLightbox = '.js-giftset-lightbox';
const lightboxOpenBtn = '[data-group-id] .js-edit-button';
const lightboxChooseBtn = '.js-lightbox-choose';
const lightboxUndoBtn = '.js-undo-button';
const sliderEl = '.js-giftset-lightbox-slider';
const simplebarEl = '.simplebar-content-wrapper';
const mobileView = $(window).width() < 768;
const defaultImage = $('#defaultImageData').val();

const pgCustomizeEvents = {
    onChange : $.Event('pgCustomize.onChange')
};

function onClickOpenLightbox() {
    $(lightboxOpenBtn).on('click', function () {
        const $this = $(this);
        let groupId = $this.closest('[data-group-id]').data('group-id');
        const $giftsetLightbox = $('.js-giftset-lightbox[data-lightboxgroup-id="' + groupId + '"]');
        const selectedChoice = $(this).parent().prev('.js-group-result-product').val();

        $this.addClass('animating');
        $('body').addClass('visible-lightbox');
        scrollHelper.disableScroll();
        $giftsetLightbox.addClass('visible');

        const $activeLightbox = $('.js-giftset-lightbox.visible');
        groupId = $activeLightbox.data('lightboxgroup-id');
        const choiceId = $('.js-lightbox-slider-item', $activeLightbox).data('choice-id');
        const selectedItem = $('.js-lightbox-slider-item[data-choice-id="' + selectedChoice + '"]', $activeLightbox);
        const $customResults = $('.js-custom-giftset .js-group-result-product').clone();
        const $activeSimplebar = $activeLightbox.find(simplebarEl);

        if (!$this.hasClass('reopened')) {
            setTimeout(function() {
                $this.addClass('reopened');
                ritualsStyles.initLazyLoad();

                $customResults.each(function(i, result) {
                    const $result = $(result);
                    if ($result.attr('id') === groupId) {
                        $result.val(choiceId);
                    }
                });

                // Trigger preload of product image
                preloadProductImage(getFinalProductID($customResults));

                $activeLightbox.find(sliderEl).scrollLeft(0);
                if ($activeSimplebar.length) {
                    $activeSimplebar.scrollLeft(0);
                }
            }, 200);
        } else {
            const scrollPosition = (selectedItem.position().left);
            $activeLightbox.find(sliderEl).scrollLeft(scrollPosition);
            if ($activeSimplebar.length) {
                $activeSimplebar.scrollLeft(scrollPosition);
            }
        }
    });
}

function updateProductList(activeLightbox, choiceId) {
    const productsListHTML = generateProductListElement(activeLightbox, choiceId);
    $('[data-group-id="' + activeLightbox.data('lightboxgroup-id') + '"] .js-giftset-product-list').empty().append(productsListHTML);
}

function resetProductList(groupId) {
    const defaultProductsListHTML = $('[data-lightboxgroup-id="' + groupId + '"] .js-default-products-list').html();
    $('[data-group-id="' + groupId + '"] .js-giftset-product-list').html(defaultProductsListHTML);
}

function resetProductImage() {
    updateImageAttributes(defaultImage);
}

function onClickCloseLightbox() {
    $(document).on('click', '.js-giftset-lightbox-close, .js-giftset-lightbox-overlay', function () {
        $(this).parents(giftsetLightbox).removeClass('visible');
        $('body').removeClass('visible-lightbox');
        scrollHelper.enableScroll();
        $(lightboxOpenBtn).removeClass('animating');
        $(sliderEl).scrollLeft(0);
        if ($(sliderEl).find(simplebarEl).length) {
            $(sliderEl).find(simplebarEl).scrollLeft(0);
        }
    });
}

function updateTotalPrice(finalProductID) {
    $.ajax({
        type: 'GET',
        url: Urls.getTotalPriceForPGProduct,
        data: {pid: finalProductID},
        success: function(data) {
            if (data) {
                const el = $('.js-total-pg-price');
                el.text(data.totalPriceDisplayValue);

                const pgProducts = $('input[name="pgProducts"]');
                if (pgProducts.length > 0) {
                    const dataLayerData = JSON.parse(pgProducts.val());
                    dataLayerData.products[0].price = data.totalPrice;
                    pgProducts.val(JSON.stringify(dataLayerData));
                }
            }
        }
    });
}

function updateDataLayerProductAvailability(finalProductID) {
    $.ajax({
        type: 'GET',
        url: Urls.getProductAvailabilityForPG,
        data: {pid: finalProductID},
        success: function(data) {
            if (data) {
                const pgProducts = $('input[name="pgProducts"]');
                if (pgProducts.length > 0) {
                    const dataLayerData = JSON.parse(pgProducts.val());
                    dataLayerData.products[0].availability = data.availability;
                    pgProducts.val(JSON.stringify(dataLayerData));
                }
            }
        }
    });
}

function onClickChangeGiftset() {
    $(document).on('click', lightboxChooseBtn, function () {
        const $this = $(this);
        const $activeLightbox = $this.parents(giftsetLightbox);
        const groupId = $activeLightbox.data('lightboxgroup-id');
        const openBtn = $('[data-group-id="' + groupId + '"] .js-edit-button');
        openBtn.removeClass('animating');

        const choiceId = $this.closest('.js-lightbox-slider-item').data('choice-id');

        if ($activeLightbox.data('default-choice') === choiceId) {
            openBtn.nextAll(lightboxUndoBtn).hide();
            openBtn.removeClass('repeat');
        } else {
            openBtn.nextAll(lightboxUndoBtn).show();
            openBtn.addClass('repeat');
        }

        $activeLightbox.find('.selected').removeClass('selected');
        $this.addClass('selected');

        $('#' + groupId).val(choiceId);
        updateProductList($activeLightbox, choiceId);
        const finalProductID = getFinalProductID();
        preloadProductImage(finalProductID);
        updateProductImage(finalProductID);
        setFinalProductValue(finalProductID);
        if (mobileView) {
            $activeLightbox.removeClass('visible');
            $('body').removeClass('visible-lightbox');
            scrollHelper.enableScroll();
            $(sliderEl).scrollLeft(0);
            if ($(sliderEl).find(simplebarEl).length) {
                $(sliderEl).find(simplebarEl).scrollLeft(0);
            }
        }
        updateTotalPrice(finalProductID);
        updateDataLayerProductAvailability(finalProductID);

        $(document).trigger(pgCustomizeEvents.onChange);
        $('.js-giftset-lightbox-close').trigger('click');
    });
}

function onClickResetGiftset() {
    $(document).on('click', '.js-undo-button', function () {
        const $this = $(this);
        const groupId = $this.closest('[data-group-id]').data('group-id');
        const lightbox = $('[data-lightboxgroup-id="' + groupId + '"]');

        $('.selected', lightbox).removeClass('selected');
        const choiceId = lightbox.data('default-choice');

        $('[data-choice-id="' + choiceId + '"] .js-lightbox-choose', lightbox).addClass('selected');

        $this.prev().removeClass('repeat');
        resetProductList(groupId);
        resetProductImage(groupId);
        $('#' + groupId).val(choiceId);
        const finalProductID = getFinalProductID();
        setFinalProductValue(finalProductID);
        $this.hide();
        updateTotalPrice(finalProductID);
        updateDataLayerProductAvailability(finalProductID);

        $(document).trigger(pgCustomizeEvents.onChange);
    });
}

function generateProductListElement(activeLightbox, choiceId) {
    const productsJson = $('[data-choice-products-id="' + choiceId + '"]', activeLightbox).val();
    const productsObj = JSON.parse(productsJson);
    const htmlElement = $('<div/>', {
        class: 'list-holder js-lightbox-product-list-inner'
    });
    $.each(productsObj.productsList, function (index, product) {
        htmlElement.append($('<span/>', {
            html: product.title
        }));
    });
    return htmlElement;
}

function preloadProductImage(finalProductID) {
    const imageObj = JSON.parse($('[data-product-image-id="' + finalProductID + '"]').val());
    if (imageObj) {
        const img = new Image();
        img.src = imageObj.largeImg;
    }
}

function updateProductImage(finalProductID) {
    const image = $('[data-product-image-id="' + finalProductID + '"]').val();
    updateImageAttributes(image);
}

function updateImageAttributes(image){
    const imagesObj = JSON.parse(image);
    if (!imagesObj) {
        return;
    }
    const prevImage = $('.js-product-main-image');
    prevImage.attr('src', imagesObj.largeImg);
    prevImage.attr('title', imagesObj.title);


    if (imagesObj.srcset) {
        prevImage.attr('srcset', imagesObj.srcset);
        prevImage.data('product-zoom', JSON.stringify({
            src:imagesObj.retinaImg,
            w:1000,
            h:1000
        }));
    }
}

function getFinalProductID(customResults) {
    // To preload the main image of the current slide we need to pass a
    // customResult to be able to use the logic below.
    const results = customResults || $('.js-custom-giftset .js-group-result-product');

    if (!results.length) {
        return '';
    }

    const existingFinalSetsElement = $('#available-final-productsets');
    if (!existingFinalSetsElement.length) {
        return '';
    }

    let existingFinalSets = existingFinalSetsElement.val().split(',');
    const selectedSubSets = results.toArray().map((group) => group.value);

    for (const idx in selectedSubSets) {
        const subset = selectedSubSets[idx];

        existingFinalSets = existingFinalSets.filter(function (finalSet) {
            return finalSet.indexOf(subset) > -1;
        });

        if (existingFinalSets.length === 1) {
            break;
        }
    }

    return existingFinalSets[0];
}

function setFinalProductValue(finalProductID, element){
    if (!element){
        element = $('input[name="finalProductID"]');
    }
    element.val(finalProductID);
}

const personalisedlightbox = {
    init: function () {
        this.ensureFinalProductIdIsSet();
        onClickOpenLightbox();
        onClickCloseLightbox();
        onClickChangeGiftset();
        onClickResetGiftset();
    },
    ensureFinalProductIdIsSet: function(form){
        const element = form ? $('input[name="finalProductID"]', form) : $('input[name="finalProductID"]');
        if (element.val()){
            return;
        }
        const finalProductID = getFinalProductID() || $('#final-productset-id').val();
        setFinalProductValue(finalProductID, element);
    }
};

module.exports = personalisedlightbox;
